import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutHeader() {
  return (
    <section className="bg-accent-500 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '关于我们' }]} />
        <h1 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">关于我们</h1>
        <p className="mt-3 max-w-2xl text-foreground-900 md:text-lg">
          了解我爱漫画网的品牌故事、网站定位、发展理念与内容原则。
        </p>
      </div>
    </section>
  );
}